import { schema } from "normalizr";
import { ShippingAccount } from "./shipping-account";

export const ShippingAccounts = new schema.Array(ShippingAccount);
